import React from 'react';
import styled from 'styled-components';
import EditHeader from '../../../../components/molecule/EditHeader';
import { connect } from 'react-redux';

import Body from './Body';

const Container = styled.div`

`
const Text = styled.div`
  font-size: 18px;
`
const StaticContainer = styled.div`
`

class Channel extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      editMode: false,
    }
  }

  submitForm = form => {
    const { onSubmit } = this.props;
    onSubmit(form, () => this.setEditMode(false));
  }

  setEditMode = (editMode) => {
    const { data, openChannelNameDialog } = this.props;

    // check for data.channel_name
    if (!data.channel_name) {
      openChannelNameDialog();
    } else {
      this.setState({ editMode });
    }
  }

  render() {
    const { data, resourceState, onSubmit, ...other } = this.props;
    const { editMode } = this.state;

    return (
      <Container {...other}>
        <EditHeader
          label="Categories"
          onClickEdit={() => this.setEditMode(true)}
          inEdit={editMode}
        />
        {
          editMode ? (
            <Body
              initialValues={data}
              submit={this.submitForm}
              onClickCancel={() => this.setEditMode(false)}
              options={resourceState.resourceData}
            />
          ) : (
            <StaticContainer>
              <Text>
                {data.categories.join(', ')}
              </Text>
            </StaticContainer>
          )
        }
      </Container>
    );
  }
}

Channel.propTypes = {

};

function mapStateToProps(state) {
  return {
    resourceState: state.resourceState,
  };
}

export default connect(mapStateToProps,null)(Channel);
